import React, { FC } from 'react';

import { Portal } from 'Modules/ui';
import { Box } from 'Modules/ui3';


export const UiPortal: FC = () => (
    <Portal>
        <Box id='ui-portal' position='absolute' zIndex={51} />
    </Portal>
);
